import request from '@/plugin/axios'
import axios from 'axios';


export function getBankInfoById(id) {
    return request({
        url: '/api/case/czBankInfo/' + id,
        method: 'get',
    })
}
export function getCastAllInfo(params) {
    return request({
        url: '/api/case/czCaseInfo/singleCase',
        method: 'get',
        params: params
    })
}

export function updateCaseBaseInfo(id, data) {
    return request({
        url: '/api/case/czCaseInfo/update/' + id,
        method: 'put',
        data
    })
}
export function updateCasePartyInfo(id, data) {
    return request({
        url: '/api/case/czParty/' + id,
        method: 'put',
        data
    })
}
export function updateCaseAgentInfo(data) {
    return request({
        url: '/api/case/czCaseAgent/' + data.id,
        method: 'put',
        data
    })
}
export function updateCaseCardInfo(data) {
    return request({
        url: '/api/case/czCardInfo/updateCardInfo',
        method: 'put',
        data
    })
}
export function updateCaseEvidenceInfo(data) {
    return request({
        url: '/api/case/czEvidence/' + data.id,
        method: 'put',
        data
    })
}

export function updateCzInstallmentInfo(data) {
    return request({
        url: '/api/case/czInstallment/' + data.id,
        method: 'put',
        data
    })
}

export function addCzInstallmentInfo(data) {
    return request({
        url: '/api/case/czInstallment',
        method: 'post',
        data
    })
}
export function addCasePartyInfo(data) {
    return request({
        url: '/api/case/czParty',
        method: 'post',
        data
    })
}
export function addAgentInfo(data) {
    return request({
        url: '/api/case/czCaseAgent',
        method: 'post',
        data
    })
}
export function deleteCasePartyInfo(id) {
    return request({
        url: '/api/case/czParty/delete/' + id,
        method: 'delete'
    })
}
export function deleteCaseczInstallment(id) {
    return request({
        url: '/api/case/czInstallment/' + id,
        method: 'delete'
    })
}
export function deleteCaseCardInfo(id) {
    return request({
        url: '/api/case/czCardInfo/deleteCardInfo/' + id,
        method: 'delete'
    })
}
export function deleteCaseAgentInfo(id) {
    return request({
        url: '/api/case/czCaseAgent/' + id,
        method: 'delete'
    })
}
export function deleteCaseEvidenceInfo(id) {
    return request({
        url: '/api/case/czEvidence/' + id,
        method: 'delete'
    })
}

export function saveOfUpdatePartyInfo(data) {
    return request({
        url: '/api/case/czParty/saveOrUpdateParty',
        method: "post",
        data
    })
}
export function addCaseCardInfo(data) {
    return request({
        url: '/api/case/czCardInfo/addCardInfo',
        method: 'post',
        data
    })
}
export function addCaseEvidenceInfo(data) {
    return request({
        url: '/api/case/czEvidence',
        method: "post",
        data
    })
}
export function autoGenerDom(data) {
    return request({
        url: '/api/case/czCaseInfo/createTruthAndClaims/' + data,
        method: 'post',
        //   params:data 
    })
}

export function ocrReq(data, token) {
    return axios({
        url: process.env.VUE_APP_API + '/api/ocr/ocrRecord/identifyEveryFile',
        method: 'post',
        dataType: 'json',
        responseType: 'application/json',
        data: data,
        headers: {
            authorization: 'Bearer ' + token,
        },

    })
}

export function getPdfByCaseId(data) {
    return request({
        url: '/api/case/fileOcrDetails/getPdfByCaseId',
        method: 'post',
        data
    })
}

export function goToPage(data) {
    return request({
        url: '/api/case/fileOcrDetails/goToPage',
        method: 'post',
        data
    })
}

//切换预览原材料的文档类型
export function changeDocPage(val, isBothContains, that) {

    if (that.flipSwitch) {
        that.docName = val;
        var arr = val.split(',')
        for (var i = 0; i < that.fileOcrDetails.length; i++) {
            var documentName = that.fileOcrDetails[i].docName
            if (documentName != "" && documentName != undefined) {
                if (isBothContains) {
                    //同时包含
                    var containsCount = 0;
                    for (var j = 0; j < arr.length; j++) {
                        if (documentName.includes(arr[j])) {
                            containsCount++;
                        }
                    }
                    if (containsCount == arr.length) {
                        // console.log("that.pageNum=" ,that.pageNum,",Number(that.fileOcrDetails[i].page="+Number(that.fileOcrDetails[i].page))
                        if (that.pageNum != Number(that.fileOcrDetails[i].page)) {
                            that.pageNum = Number(that.fileOcrDetails[i].page)
                            that.pageTotalNum = Number(that.fileOcrDetails[i].totalPage)
                            break;
                        }
                        // console.log("that.pageNum=" ,that.pageNum)
                    }
                } else {
                    let page = 0;
                    let totalpage = 0;
                    for (var j = 0; j < arr.length; j++) {
                        if (documentName.includes(arr[j])) {
                            if (that.pageNum != Number(that.fileOcrDetails[i].page)) {
                                page = Number(that.fileOcrDetails[i].page)
                                totalpage = Number(that.fileOcrDetails[i].totalPage)
                                break;
                            }
                        }
                    }
                    if (page != 0 && totalpage != 0) {
                        that.pageNum = page
                        that.pageTotalNum = totalpage
                        break;
                    }

                }
            }
        }
    }

}

//跳转身份证
export function changeIdCardPage(index, that) {
    const idCardArr = [];
    index = Number(index)
    for (var i = 0; i < that.fileOcrDetails.length; i++) {
        var documentName = that.fileOcrDetails[i].docName
        if (documentName != "" && documentName != undefined) {
            if (documentName == "身份证") {
                idCardArr.push(that.fileOcrDetails[i]);
            }
        }
    }
    if (that.flipSwitch) {
        if (idCardArr.length > 0 && (idCardArr.length - 1) >= index) {
            if (that.pageNum != Number(idCardArr[index].page)) {
                that.pageNum = Number(idCardArr[index].page)
                that.pageTotalNum = Number(idCardArr[index].totalPage)
            }

        }
    }

}

export function changeDocDate(dateType, that) {
    console.log(that.flipSwitch)
    var page = 1;
    var dateCount = 0;
    if (that.flipSwitch) {
        if (dateType == "逾期日期") {
            for (var i = 0; i < that.fileOcrDetails.length; i++) {
                var documentName = that.fileOcrDetails[i].docName
                if (documentName != "" && documentName != undefined) {
                    if (documentName === "交易明细") {
                        if (that.fileOcrDetails[i].content != undefined) {
                            if (that.fileOcrDetails[i].content.includes("逾期还款违约金")) {
                                if (that.pageNum != Number(that.fileOcrDetails[i].page)) {
                                    that.pageNum = Number(that.fileOcrDetails[i].page)
                                    that.pageTotalNum = Number(that.fileOcrDetails[i].totalPage)
                                    page = Number(that.fileOcrDetails[i].page)
                                    break;
                                }
                            }
                        }
                        if(dateCount < 1){
                            page = Number(that.fileOcrDetails[i].page)
                        }
                        dateCount++;
                    }
                }
    
            }
            that.pageNum = page
        }
        if (dateType == "截止日期") {
            for (var i = that.fileOcrDetails.length-1; i >= 0; i--) {
                if (that.fileOcrDetails[i].docName != undefined) {
                    var documentName = that.fileOcrDetails[i].docName
                    if (documentName != "" && documentName != undefined) {
                        if (documentName === "交易明细") {
                            that.pageNum = Number(that.fileOcrDetails[i].page)
                            that.pageTotalNum = Number(that.fileOcrDetails[i].totalPage)
                            console.log("交易明细=" ,that.pageNum)
                            break;
                        }
                    }
                }
    
            }
        }
    }
    
}